import { IconNew, ModBox } from '@jfs/ui-new'
import React from 'react'

const Delete = React.memo(({ onDelete, isEditMode }: any) => {
  return (
    <ModBox flexDirection={'row'} show={isEditMode} alignItems={'flex-end'}>
      <ModBox
        width={32}
        borderWidth={1}
        borderColor={'GRAY_BORDER'}
        borderRadius={4}
        alignItems={'center'}
        justifyContent={'center'}
        onPress={onDelete}
        underlayColor={'DISABLED_GREY'}>
        <IconNew id={'DELETE'} color={'BLACK_21'} />
      </ModBox>
    </ModBox>
  )
})

export { Delete }
